export type IPatientInformationError = {
       name: string;
       gender: string;
       age: string;
       address: string;
       houseNo: string;
       city: String;
       locality: string;
       state: string;
       postalCode: string;
       mobileNo: string;
       secondaryNo: string;
       alternateNo: string;
       HospitalNo: string;
       disease: string;
       recruitment_date: string;
}

export const defaultPatientInformationError: IPatientInformationError = {
       name: "",
       gender: "",
       age: "",
       address: "",
       houseNo: "",
       city: "",
       locality: "",
       state: "",
       postalCode: "",
       mobileNo: "",
       secondaryNo: "",
       alternateNo: "",
       HospitalNo: "",
       disease: "",
       recruitment_date: "",
}